import React, { Component } from "react";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import {AuthProvider} from "./auth/authProvider";
import {
  config,
  sessionAccessToken, sessionActiveTime,
  sessionRefreshToken,
  sessionUser,
  sessionUsername,
  sessionUserPerms,
  useKeycloak
} from "./config";
import {getUserByUsername, getUserPermissionsByUsername} from "./services/userService";
import {logActivity, lookupIP} from "./services/utilService";
import MainApp from "./MainApp";
import {BASE_URL} from "./auth/authConfig";
import Keycloak from "keycloak-js";
import CustomLoader from './components/common/Loader';

export let userDetails = {}

class App extends Component {
  constructor(props){
    super(props);
    this.state={
      showSidebar: false,
      isValidIP : 'True',
      navPx: 0,
      authenticated: false,
      userDetails: null,
      keycloak: null,
      load: true,
    }
  }

  handleToggle = () => {
    this.setState({showSidebar: !this.state.showSidebar})
  }

  handleSetNavPx = (newPx) => {
    this.setState({navPx: newPx})
  }

  keycloakLogout = () => {
    let {keycloak} = this.state;
    sessionStorage.removeItem(sessionUser);
    sessionStorage.removeItem(sessionUsername);
    sessionStorage.removeItem(sessionAccessToken);
    sessionStorage.removeItem(sessionRefreshToken);
    sessionStorage.removeItem(sessionActiveTime);
    sessionStorage.removeItem(sessionUserPerms);
    window.location = BASE_URL + "home";
    if(keycloak.logout != null) {
      // window.location = `${config.identityServerURL}/protocol/openid-connect/logout?redirect_uri=${encodeURIComponent(config.logout_uri)}`
      keycloak.logout();
    }
  }

  async componentDidMount() {

    // IP filtering
    try {
      await lookupIP().then((resp) => {
        let isValidIP = resp.data;
        console.log('isValidIP', resp.data)
        this.setState({ isValidIP, load: false })
      });
    }
    catch (e) {
      console.error('Component Load failed: ', e)
    }

    let {keycloak} = this.state;
    if(useKeycloak && (keycloak == null || keycloak.refreshToken == null)) {
      let newKeycloak = new Keycloak({
        realm: 'MQuarkV2',
        url: config.identityServerURL,
        clientId: config.client_id
      })
      await newKeycloak.init({onLoad: 'login-required'}).then(authenticated => {
        sessionStorage.setItem(sessionAccessToken, newKeycloak.token);
        sessionStorage.setItem(sessionRefreshToken, newKeycloak.refreshToken);
        getUserByUsername(newKeycloak.tokenParsed['username']).then(resp => {
          sessionStorage.setItem(sessionUser, JSON.stringify(resp.data[0]));
          sessionStorage.setItem(sessionUsername, newKeycloak.tokenParsed['username']);
          getUserPermissionsByUsername(newKeycloak.tokenParsed['username']).then(resp2 => {
            sessionStorage.setItem(sessionUserPerms, JSON.stringify(resp2.data));
            // window.location = BASE_URL + "home";
            logActivity("/login", "LOGIN_SUCCESS");
            console.log('authentication success')
            this.setState({keycloak: newKeycloak, authenticated: true})
          });
        }).catch(reason => console.log('authentication failed: ' + reason));
        // console.log(authenticated)
      })
    }
  }

  refreshKeycloakToken = () => {
    let {keycloak} = this.state;
    if(useKeycloak && (keycloak != null && keycloak.refreshToken != null)) {
      keycloak.updateToken(120)
    }
  }

  render() {
    const loading = sessionStorage.getItem(sessionUsername) == null
    const {userDetails, showSidebar, authenticated, navPx, isValidIP, load} = this.state;
    if (load) {
      return <CustomLoader loading={load} />;
    }
    if (isValidIP.includes('.')) {
      return (
        <div>
          <br />
          <h3 className="ml-4">OOPS! Your IP {isValidIP} does not have permission to access this website. Please contact your site administrator or kindly ignore if you came here by mistake.</h3>
        </div>
      );
    }
    if (isValidIP.includes('True')) {
      return (
        <>
          {
            !useKeycloak &&
            <AuthProvider key={isValidIP}>
              <MainApp key={isValidIP} loading={loading} userDetails={userDetails} showSidebar={showSidebar} handleToggle={this.handleToggle} keycloakLogout={this.keycloakLogout} refreshKeycloakToken={this.refreshKeycloakToken} handleSetNavPx={this.handleSetNavPx} navPx={navPx} />
            </AuthProvider>
          }
          {useKeycloak && authenticated &&
            <MainApp key={isValidIP} loading={loading} userDetails={userDetails} showSidebar={showSidebar} handleToggle={this.handleToggle} keycloakLogout={this.keycloakLogout} refreshKeycloakToken={this.refreshKeycloakToken} handleSetNavPx={this.handleSetNavPx} navPx={navPx} />
          }
        </>
      );
    }
  }

}

export default App;
